<template>
  <span />
</template>

<script>
import { CLIENT_URL, IMAGE_URL } from '../../assets/js/constants'
export default {
  props: {
    article: {
      type: Object,
      required: true
    }
  },
  jsonld () {
    return {
      '@context': 'http://schema.org',
      '@type': 'Article',
      mainEntityOfPage: {
        '@type': 'WebPage',
        '@id': `${CLIENT_URL}/${this.article.slug}/`,
        dateModified: this.article.updated_at,
        publisher: {
          '@type': 'Organization',
          name: 'www.salon-love-forever.ru',
          logo: {
            '@type': 'ImageObject',
            url: 'https://www.salon-love-forever.ru/img/logos/logo.jpg'
          }
        }
      },
      headline: this.article.title,
      name: this.article.title,
      image: this.article.images && this.article.images.length > 0 ? `${IMAGE_URL}/uploads/${this.article.images[0].hash}${this.article.images[0].ext}` : '',
      datePublished: this.article.created_at,
      dateModified: this.article.updated_at,
      author: { '@type': 'Person', name: 'www.salon-love-forever.ru' },
      publisher: {
        '@type': 'Organization',
        name: 'www.salon-love-forever.ru',
        logo: {
          '@type': 'ImageObject',
          url: 'https://www.salon-love-forever.ru/img/logos/logo.jpg'
        }
      },
      description: this.article.seo ? this.article.seo.description : ''
    }
  }
}

</script>
